import { BaseAssetFragment, CalendarEvent_AttendeeFragment } from "graphql.generated";
import { EventStatuses } from "src/app/schedules/dispatch/store/dispatch.reducer";

import { JobsV2EventLocation } from "../../../job-tool.reducer";

import { EventType } from "./timeline-create-event.component";

export const jobCreateEventDialogInitialState = {
  createEventDialogVisible: false as boolean,
  createEventDialog: {
    selectedEventId: undefined as string | undefined,
    eventType: undefined as EventType | undefined,
    eventTypeDisabled: false as boolean,
    title: '' as string,
    status: undefined as EventStatuses | undefined,
    assets: [] as BaseAssetFragment[],
    locations: [] as JobsV2EventLocation[],
    attendees: [] as CalendarEvent_AttendeeFragment[],
    validationErrors: {} as { [key: string]: string },
    assetSuggestions: [] as BaseAssetFragment[],
    attendeeSuggestions: [] as CalendarEvent_AttendeeFragment[],
  },
}
